window.addEventListener('DOMContentLoaded', function () {
  /* Swiper */
  //initialize swiper when document ready
  var mySwiper = new Swiper('.swiper-container', {
    slidesPerView: 1,
    autoplay: {
      delay: 3000,
    },
    centeredSlides: true,
    spaceBetween: 10,
    speed: 500,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  mySwiper.on('slideChange', function () {
    if (mySwiper.isEnd) {
      mySwiper.autoplay.stop();
      mySwiper.off('slideChange');
    }
  });
});
